import React from "react";
import userDefault from '../../../assets/images/user-default.svg';
import gender from '../../../assets/images/gender.svg';
import height from '../../../assets/images/height.svg';
import { getAge } from '../../../helper';

const UserDetails = ({user}) => {
    return(
      <>
        <p className="text-center user-detail-text">This test takes less than 2 mins!</p>
        <h4 className="user-detail-title">This assessment is for</h4>
        <div className='patient-detail-card mt-0'>
          <div className="d-flex align-items-start align-items-center mb-3">
            <img className="me-3 rounded-circle" src={userDefault} width={30} alt='' />
            <h5 className="mt-0 mb-0 text-capitalize">{user.fullName}</h5>
          </div>
          <div className="d-flex align-items-start align-items-center mb-3">
            <img className="me-3 rounded-circle" src={gender} width={24} alt='' />
            <p className="mt-0 mb-0 text-capitalize">{user.gender}</p>
          </div>
          <div className="d-flex align-items-start align-items-center">
            <img className="me-3 rounded-circle" src={height} width={24} alt='' />
            <p className="mt-0 mb-0">{getAge(user.dob)} years old</p>
          </div>
        </div>
      </>
    )
}

export default UserDetails